import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import { BlogsProvider } from './context/BlogsContext';

import HomePage from './pages/HomePage';
import BlogsPage from './pages/BlogsPage';
import CategoryPage from './pages/CategoryPage';
import BlogDetailPage from './pages/BlogDetailPage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import NotFound from './pages/NotFound';
import Admin from './Admin';
import Callback from './Callback';
import DevLogin from './DevLogin';

// Reset scroll on route change (the browser restores it on back/forward itself,
// but a fresh push should always start at the top of the article).
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// /admin and /callback are chrome-free: no header/footer, and robots.txt
// disallows them.
function SiteLayout({ children }) {
  return (
    <>
      {/* First focusable element on the page, so keyboard and screen-reader
          users can jump past the header and category nav on every route. */}
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header />
      <main className="site-main" id="main">
        {children}
      </main>
      <Footer />
    </>
  );
}

const withLayout = (element) => <SiteLayout>{element}</SiteLayout>;

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <BlogsProvider>
        <Routes>
          <Route path="/" element={withLayout(<HomePage />)} />
          <Route path="/blogs" element={withLayout(<BlogsPage />)} />
          <Route path="/category/:categorySlug" element={withLayout(<CategoryPage />)} />
          <Route path="/blog/:categorySlug/:slug" element={withLayout(<BlogDetailPage />)} />
          <Route path="/about" element={withLayout(<AboutPage />)} />
          <Route path="/privacy-policy" element={withLayout(<PrivacyPolicy />)} />
          <Route path="/terms" element={withLayout(<TermsOfService />)} />

          {/* Admin — auth handled inside Admin.js (redirects to Cognito) */}
          <Route path="/admin" element={<Admin />} />
          <Route path="/callback" element={<Callback />} />

          {/* Dev helper: populate localStorage with tokens for testing. Only available in non-production builds. */}
          {process.env.NODE_ENV !== 'production' && (
            <Route path="/dev-login" element={<DevLogin />} />
          )}

          <Route path="*" element={withLayout(<NotFound />)} />
        </Routes>
      </BlogsProvider>
    </BrowserRouter>
  );
}

export default App;
